import { c as _c } from "react/compiler-runtime";
import type { RefObject } from "react";
import WaveSettingEditorActions from "./WaveSettingEditorActions";
type ApprovalThresholdTimeUnit = "minutes" | "hours";
type ApprovalThresholdEditorField = "threshold" | "holdTime";
interface WaveApprovalThresholdsEditorFormProps {
  readonly disabled: boolean;
  readonly field: ApprovalThresholdEditorField;
  readonly inputRef: RefObject<HTMLInputElement | null>;
  readonly minTimeValue: string;
  readonly onCancel: () => void;
  readonly onMinTimeValueChange: (value: string) => void;
  readonly onSave: () => void;
  readonly onThresholdValueChange: (value: string) => void;
  readonly onUnitChange: (unit: ApprovalThresholdTimeUnit) => void;
  readonly thresholdValue: string;
  readonly unit: ApprovalThresholdTimeUnit;
}
const APPROVAL_THRESHOLD_TIME_UNITS = ["minutes", "hours"] as const;
const isApprovalThresholdTimeUnit = (value: string): value is ApprovalThresholdTimeUnit => APPROVAL_THRESHOLD_TIME_UNITS.some(unit => unit === value);
export default function WaveApprovalThresholdsEditorForm(t0) {
  const $ = _c(26);
  const {
    disabled,
    field,
    inputRef,
    minTimeValue,
    onCancel,
    onMinTimeValueChange,
    onSave,
    onThresholdValueChange,
    onUnitChange,
    thresholdValue,
    unit
  } = t0;
  const showThreshold = field === "threshold";
  const showHoldTime = field === "holdTime";
  let t1;
  if ($[0] !== onSave) {
    t1 = event => {
      event.preventDefault();
      onSave();
    };
    $[0] = onSave;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== disabled || $[3] !== inputRef || $[4] !== onThresholdValueChange || $[5] !== showThreshold || $[6] !== thresholdValue) {
    t2 = showThreshold && <label className="tw-flex tw-flex-col tw-gap-1.5 tw-text-sm tw-font-medium tw-text-iron-100"><span>Required approvals</span><input ref={inputRef} aria-label="Required approvals" autoComplete="off" autoFocus={true} className="tw-min-w-0 tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-2.5 tw-py-2 tw-text-sm tw-text-iron-100 focus:tw-border-primary-400 focus:tw-outline-none" disabled={disabled} inputMode="numeric" type="text" value={thresholdValue} onFocus={_temp} onChange={event_1 => onThresholdValueChange(event_1.target.value)} /></label>;
    $[2] = disabled;
    $[3] = inputRef;
    $[4] = onThresholdValueChange;
    $[5] = showThreshold;
    $[6] = thresholdValue;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== disabled || $[9] !== minTimeValue || $[10] !== onMinTimeValueChange || $[11] !== onUnitChange || $[12] !== showHoldTime || $[13] !== unit) {
    t3 = showHoldTime && <div className="tw-flex tw-flex-col tw-gap-1.5 tw-text-sm tw-font-medium tw-text-iron-100"><span>Hold time</span><div className="tw-flex tw-gap-2"><input aria-label="Minimum time above threshold" autoComplete="off" autoFocus={true} className="tw-min-w-0 tw-flex-1 tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-2.5 tw-py-2 tw-text-sm tw-text-iron-100 focus:tw-border-primary-400 focus:tw-outline-none" disabled={disabled} inputMode="numeric" type="text" value={minTimeValue} onFocus={_temp2} onChange={event_3 => onMinTimeValueChange(event_3.target.value)} /><select aria-label="Minimum time above threshold unit" className="tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-2.5 tw-py-2 tw-text-sm tw-text-iron-100 focus:tw-border-primary-400 focus:tw-outline-none" disabled={disabled} value={unit} onChange={event_4 => {
          if (isApprovalThresholdTimeUnit(event_4.target.value)) {
            onUnitChange(event_4.target.value);
          }
        }}>{APPROVAL_THRESHOLD_TIME_UNITS.map(_temp3)}</select></div></div>;
    $[8] = disabled;
    $[9] = minTimeValue;
    $[10] = onMinTimeValueChange;
    $[11] = onUnitChange;
    $[12] = showHoldTime;
    $[13] = unit;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== showHoldTime) {
    t4 = showHoldTime && <p className="tw-mb-0 tw-text-xs tw-leading-5 tw-text-iron-400">Leave hold time blank for immediate approval.</p>;
    $[15] = showHoldTime;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== disabled || $[18] !== onCancel) {
    t5 = <WaveSettingEditorActions disabled={disabled} onCancel={onCancel} />;
    $[17] = disabled;
    $[18] = onCancel;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5) {
    t6 = <form className="tw-flex tw-flex-col tw-gap-3" onSubmit={t1}>{t2}{t3}{t4}{t5}</form>;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
}
function _temp3(timeUnit) {
  return <option key={timeUnit} value={timeUnit}>{timeUnit}</option>;
}
function _temp2(event_2) {
  return event_2.currentTarget.select();
}
function _temp(event_0) {
  return event_0.currentTarget.select();
}
export type { ApprovalThresholdTimeUnit };
export type { ApprovalThresholdEditorField };